module.exports = __webpack_public_path__ + "static/img/online-verkaufen-img.d3188b8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/base/online-verkaufen-img.jpeg
// module id = auQQ
// module chunks = 1